// Empty — estado vacío con display title, body opcional y CTA opcional.

export default function Empty({ title, sub, action, className = '' }) {
  return (
    <div className={`text-center py-16 px-6 ${className}`}>
      <div className="font-display text-[28px] text-[var(--ink)]">{title}</div>
      {sub && <p className="text-[13px] text-[var(--ink-3)] mt-2 max-w-md mx-auto">{sub}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
